import { inject, type ComputedRef, type InjectionKey } from 'vue';

import type { User } from '@/shared/api';

type SharedUser = Pick<User, 'id' | 'email' | 'username' | 'firstName' | 'lastName'>;

const UserContextKey = Symbol() as InjectionKey<ComputedRef<SharedUser>>;

const prepareSharedUser = (user: User): SharedUser => ({
  id: user.id,
  email: user.email,
  username: user.username,
  firstName: user.firstName,
  lastName: user.lastName,
});

const useSharedUser = (): ComputedRef<SharedUser> => {
  const user = inject<ComputedRef<SharedUser>>(UserContextKey);

  if (!user) {
    throw new Error('useSharedUser() must be used within an AuthenticatedLayout / Provider');
  }

  return user;
};

export { type SharedUser, UserContextKey, prepareSharedUser, useSharedUser };
